import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Globe } from "lucide-react";
import { useLanguage, useT } from "@/contexts/LanguageContext";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { lang, toggleLang } = useLanguage();
  const t = useT();

  const links = [
    { href: "/", label: t("nav_home") },
    { href: "/#leistungen", label: t("nav_services") },
    { href: "/#kontakt", label: t("nav_contact") },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <nav data-testid="main-navbar" className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img src="/logo.png" alt="AtoB Logistic Solutions GmbH" className="h-16 w-auto" />
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {links.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`nav-link text-sm font-medium transition-colors ${
                  isActive(link.href) ? "text-[#002FA7]" : "text-[#475569] hover:text-[#0A0A0A]"
                }`}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={toggleLang}
              className="flex items-center gap-1.5 text-sm font-medium text-[#475569] hover:text-[#002FA7] transition-colors border border-border rounded-sm px-3 py-1.5"
              data-testid="language-toggle"
            >
              <Globe className="w-3.5 h-3.5" />
              {lang === "de" ? "EN" : "DE"}
            </button>
          </div>

          <button
            className="md:hidden p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-border" data-testid="mobile-menu">
          <div className="px-4 py-4 space-y-3">
            {links.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="block text-sm font-medium text-[#475569] hover:text-[#002FA7] transition-colors"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <button
              onClick={toggleLang}
              className="flex items-center gap-1.5 text-sm font-medium text-[#475569] hover:text-[#002FA7] transition-colors"
              data-testid="mobile-language-toggle"
            >
              <Globe className="w-3.5 h-3.5" />
              {lang === "de" ? "Switch to English" : "Auf Deutsch wechseln"}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
